import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "BundleChunk" */ './Bundle'), {
    fallback: null,
});
